import {Component, OnInit} from '@angular/core';
import {PhotographerService} from '../../services/photographer/photographer.service';
import {Photographer} from '../../entities/photographer/photographer.entity';
import {ActivatedRoute} from '@angular/router';
import {PhotographerProfile} from '../../components/photographer/photographer-profile/photographer-profile';
import {PhotographerServices} from '../../components/photographer/photographer-services/photographer-services';
import {PhotographerPortfolio} from '../../components/photographer/photographer-portfolio/photographer-portfolio';
import {PortfolioPhoto} from '../../../core/entities/portfolio/portfolio-photo.entity';
import {PortfolioService} from '../../services/portfolio/portfolio.service';
import {SeoService} from '../../../core/services/seo/seo.service';
import {
  PhotographerBookNowModal
} from '../../../creator/components/photographer-book-now-modal/photographer-book-now-modal';
import {AnalyticsService} from '../../../core/services/analytics/analytics.service';
import {TrackingService} from '../../../core/services/tracking/tracking.service';
import {TrackingEventName} from '../../../core/entities/tracking/tracking-event.entity';
import {Service} from '../../entities/photographer/service.entity';
import {TranslocoPipe} from '@jsverse/transloco';
import {Footer} from '../../../core/components/footer/footer';

@Component({
  selector: 'app-photographe',
  imports: [
    PhotographerProfile,
    PhotographerServices,
    PhotographerPortfolio,
    PhotographerBookNowModal,
    Footer,
  ],
  templateUrl: './photographer.component.html',
  standalone: true,
  styleUrl: './photographer.component.scss'
})
export class PhotographerComponent implements OnInit {
  public photographer: Photographer|null = null;
  public portfolio: PortfolioPhoto[]|null = null;
  public loading = false;
  public bookNowModalOpened = false;
  private hasTrackedProfile = false;

  public constructor(
    private readonly photographerService: PhotographerService,
    private readonly portfolioService: PortfolioService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly seoService: SeoService,
    private readonly analytics: AnalyticsService,
    private readonly tracking: TrackingService,
  ) {
  }
  public ngOnInit() {
    this.loading = true;
    this.activatedRoute.paramMap.subscribe((params) => {
      const slug = params.get('slug');
      if (slug) {
        this.photographerService.getPhotographer(slug).subscribe(
        (photographer) => {
          photographer.services = photographer.services.sort((a, b) => a.position - b.position);
          this.photographer = photographer;
          console.log(this.photographer);
          this.seoService.setupSEOForPhotographer(this.photographer);
          this.trackProfileView();
          this.portfolioService.getPortfolio(this.photographer.id).subscribe(
            (portfolio) => (this.portfolio = portfolio),
          );
          this.loading = false;
        },
          (error) => {
            this.loading = false;
            console.error('Error fetching photographer:', error);
          }
        );
      }
    });
  }

  public openBookNowModal(): void {
    if (this.photographer) {
      this.tracking.track(TrackingEventName.PHOTOGRAPHER_PAGE_BOOK_NOW_CLICK, {
        photographer_id: this.photographer.id,
        photographer_slug: this.photographer.slug,
        services_count: this.photographer.services?.length ?? 0,
      }, {
        gaEventName: 'click_book_now',
        flow: 'photographer_modal',
      });
    }
    this.bookNowModalOpened = true;
  }

  public closeBookNowModal(): void {
    this.bookNowModalOpened = false;
  }

  public onServiceClick(service: Service): void {
    if (!this.photographer) return;
    const payload = {
      service_id: service.id,
      service_name: service.name,
      photographer_id: this.photographer.id,
      photographer_slug: this.photographer.slug,
      source: 'profile_services',
    };
    this.analytics.event('select_service', payload);
    this.tracking.track(TrackingEventName.PHOTOGRAPHER_MODAL_SERVICE_SELECTED, payload, {
      gaEventName: 'photographer_modal_service_selected',
      flow: 'photographer_modal',
    });
  }

  private trackProfileView(): void {
    if (this.hasTrackedProfile || !this.photographer) return;
    this.tracking.track(
      TrackingEventName.PHOTOGRAPHER_PAGE_VIEW,
      {
        photographer_id: this.photographer.id,
        photographer_slug: this.photographer.slug,
        city: this.photographer.city,
        services_count: this.photographer.services?.length ?? 0,
        tags: this.photographer.tags ?? [],
      },
      {
        gaEventName: 'photographer_page_view',
        flow: 'photographer_modal',
      }
    );
    this.hasTrackedProfile = true;
  }
}
